import { useContext, useEffect, useState } from "react";
import {
  fillUpDays,
  getPrimariesBetween,
  setupCalendarVariables,
  sortJobsDuringDay,
} from "../helperFunctions/calendarFunctions";

import { JobsheetsContext } from "../providers/JobsheetsProvider";
import { TimesheetsContext } from "../providers/TimesheetsProvider";
import {QuotesContext } from "../providers/QuotesProvider";

const useCalendar = (baseDate1, baseDate2 = null) => {
  const { timesheets } = useContext(TimesheetsContext);
  const { timesheets: jobsheets } = useContext(JobsheetsContext);
  const { timesheets: quotes } = useContext(QuotesContext);

  let [startingDate, setStartingDate] = useState(null);
  let [endingDate, setEndingDate] = useState(null);

  // Array containing objects with date and label (ie. "Tue") of shown week
  let [calendarData, setCalendarData] = useState([]);

  useEffect(() => {
    // console.log("Running calendar again", baseDate1);
    /*
    if one date provided. Just get current week based around that date

    if two dates are provided, get calendar data between those two days
    */

    // Sets up calendar variables
    let { startDate, endDate, days } = setupCalendarVariables(
      baseDate1,
      baseDate2
    );

    // Get timesheets and jobsheets booked in within current shown week
    let relevantPrimaries = getPrimariesBetween(
      [timesheets, jobsheets, quotes],
      startDate,
      endDate
    );

    // Inject booked in jobs to days array
    let filledUpDays = fillUpDays(relevantPrimaries, days);

    // Sort jobs into correct order
    let sortedDayData = sortJobsDuringDay(filledUpDays);

    // Add a time difference divider between jobs
    // let newDays = addTimeDifferenceBetweenJobs(sortedDayData);

    setStartingDate(startDate);
    setEndingDate(endDate);
    setCalendarData(sortedDayData);
  }, [baseDate1, baseDate2, timesheets, jobsheets]);

  return [calendarData, startingDate, endingDate];
};

export default useCalendar;
